import React, { useState } from 'react';

import { useField } from 'formik';

import { Typography } from 'homer-web-app-components';

import classNames from 'classnames';

import { Radio, RadioToggle, TurnOnModal } from '../../../Common';

import './index.scss';

const MutateTaskActive = ({ name, ...props }) => {
  const [taskActiveModalIsOpen, setTaskActiveModalIsOpen] = useState(false);
  const toggleTaskActiveModal = () => {
    setTaskActiveModalIsOpen((prevState) => !prevState);
  };

  const [field, , fieldHelpers] = useField(name);

  return (
    <>
      <Typography
        component="div"
        variant={Typography.THEME.VARIANTS.TITLE_SMALL}
      >
        Active
      </Typography>
      <RadioToggle
        {...props}
        className={classNames('mutate-task-active', props.className)}
      >
        <Radio
          value
          onChange={() => {
            toggleTaskActiveModal();
          }}
          checked={field.value === true || field.value === 'true'}
          data-testid="on"
        >
          On
        </Radio>
        <Radio
          value={false}
          onChange={() => {
            toggleTaskActiveModal();
          }}
          checked={field.value === false || field.value === 'false'}
          data-testid="off"
        >
          Off
        </Radio>
      </RadioToggle>
      {taskActiveModalIsOpen && (
        <TurnOnModal
          state={!field.value ? 'on' : 'off'}
          handleSubmit={(value) => {
            fieldHelpers.setValue(value);
          }}
          onCancel={() => {}}
          onClose={() => {
            toggleTaskActiveModal();
          }}
        />
      )}
    </>
  );
};

export default MutateTaskActive;
